export function waitForElementToExist(root: HTMLElement | ShadowRoot, selector: string) {
  return new Promise(resolve => {
    if (root.querySelector(selector)) {
      return resolve(root.querySelector(selector));
    }

    const observer = new MutationObserver(() => {
      if (root.querySelector(selector)) {
        resolve(root.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      subtree: true,
      childList: true,
    });
  });
}
